<template>
  <div>
    <v-aside />
    <v-main class="main">
      <v-container fluid>
        <template v-if="routeIsAllowed">
          <router-view :key="$route.path" />
        </template>
        <access-denied v-else />
      </v-container>
      <update-app-massage />
    </v-main>
  </div>
</template>

<script>
  import vAside from '@/components/aside/Aside'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import _ from 'lodash'
  import AccessDenied from '@/components/app/AccessDenied.vue'
  import UpdateAppMassage from '@/components/UpdateAppMassage.vue'

  export default {
    name: 'StatisticCleanLayout',
    components: {
      UpdateAppMassage,
      AccessDenied,
      vAside,
    },
    mixins: [mixinSnackbarMessage],
    computed: {
      routeIsAllowed () {
        if (_.isEmpty(this.$route?.meta?.permissions)) {
          return true
        }
        return this.userCan(this.$route.meta.permissions)
      },
    },
    created () {
      this.$store.commit('app/showFloatingButtons')
    },
  }
</script>

<style lang="less" scoped>
::v-deep {
  .v-main {
    transition: none !important;
    padding-top: 0 !important;
  }

  /*.media-lg({
    .v-main {
      padding-top: 20px !important;
      .container {
        padding: 0 5px;
      }
    }
  })*/
}
</style>
